import React, { useState } from 'react';

const Products: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState<string>('all');

  const products = [
    {
      title: 'Money Pro',
      description: 'Track Money flexibility, Easy and efficient track income, and expense.',
      type: 'Web App',
      price: 'paid',
      gumroadLink: 'https://1.envato.market/c/2617568/950273/4415?u=https%3A%2F%2Fcodecanyon.net%2Fitem%2Fmoney-pro-cashflow-and-budgeting-manager%2F20657801',
      features: ['Income/Expense Tracking', 'Budget Management', 'Rich Reporting', 'Analytics Dashboard'],
      image: '💰',
      productImage: '/images/money-pro.jpg' // Add your actual image path here
    },

    {
      title: 'HireTrack - AI Recruitment Tracking System',
      description: 'Hire smarter. Track faster. Close roles with AI on your side.',
      type: 'Web App',
      price: 'paid',
      gumroadLink: ' https://gum.co/u/umz00dzs',
      features: ['Applicant Tracking', 'AI bot Assistance', 'Recruitment system', 'CV parsing'],
      image: '💰',
      productImage: '/images/hiretrack-ai-recruitment.png' // Add your actual image path here
    },


    {
      title: 'KalenAI - AI-Powered Calendar Assistant',
      description: 'A modern, self-hosted appointment scheduling platform with the power of AI-driven scheduling',
      type: 'Web App',
      price: 'paid',
      gumroadLink: 'https://codecanyon.net/item/kalenai-ai-powered-appointment-scheduling-platform/62068916',
      features: ['AI Scheduling', 'Calendar Integration', 'Automated Reminders', 'Appointment Management'],
      image: '💰',
      productImage: '/images/kalenai-calendar-assistant.png' // Add your actual image path here
    },


    {
      title: 'SimIn - Inventory Management System ',
      description: 'The ultimate tool for seamless control over your business supply chain.',
      type: 'Web App',
      price: 'paid',
      gumroadLink: 'https://captivlab.gumroad.com/l/simpleinventorysystem?utm_source=website&utm_medium=website&utm_campaign=captivlab',
      features: ['Inventory Tracking', 'Warehouse Management', 'Robust Reporting', 'Category Management'],
      image: '💰',
      productImage: '/images/simin-inventory.png' // Add your actual image path here
    },
    

    

    {
      title: 'Passman - Password Manager for Ultimate Protection',
      description: 'The ultimate tool for seamless control over your passwords.',
      type: 'Web App',
      price: 'paid',
      gumroadLink: 'https://captivlab.gumroad.com/l/passman?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=passman',
      features: ['License Management', 'Role based access control', 'Activity logging', 'Password sharing','Password Generator'],
      image: '💰',
      productImage: '/images/passman-password-manager.png' // Add your actual image path here
    },
    {
      title: 'M-Assets - Asset Insight & Management',
      description: 'A powerful project management tool to track your asset easily.',
      type: 'Web App',
      price: 'paid',
      gumroadLink: 'https://1.envato.market/c/2617568/950273/4415?u=https://codecanyon.net/item/massets-asset-insight-asset-management/29654029',
      features: ['Asset Management', 'Component Management', 'Asset & Component Tracking', 'Asset maintenance tracking'],
      image: '💰',
      productImage: '/images/m-asset.jpg' // Add your actual image path here
    },
    {
      title: 'Strava Companion Dashboard – Fitness Tracker in Notion',
      description: 'Your entire running, cycling, and workout life — organized beautifully in Notion.',
      type: 'Notion Pages',
      price: 'paid',
      gumroadLink: 'https://captivlab.gumroad.com/l/stravatracker?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=strava',
      features: ['Weekly Planner', 'Activity Log', 'Monthly Goals', 'Workout Journal', 'Gear Tracker'],
      image: '📊',
      productImage: '/images/strava-system.png' // Add your actual image path here
    },
    {
      title: 'Digital Asset System in Notion',
      description: 'DAM provides a centralized hub for storing and organizing your digital assets',
      type: 'Notion Pages',
      price: 'paid',
      gumroadLink: 'https://captivlab.gumroad.com/l/digitalassetsystem?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=digitalasset',
      features: ['Storing digital assets', 'Marketing Asset tracking', 'Social media content', 'Calendar Planning'],
      image: '📊',
      productImage: '/images/digital-asset.webp' // Add your actual image path here
    },
    {
      title: 'Inventory Management System (Notion)',
      description: 'Transform your asset management process with this powerful Notion ',
      type: 'Notion Pages',
      price: 'paid',
      gumroadLink: 'https://captivlab.gumroad.com/l/inventorynotion?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=notioninventory',
      features: ['Categorize and Organize', 'Track Asset Locations', 'Monitor Stock Movements', 'Multi-Warehouse Tracking'],
      image: '📊',
      productImage: '/images/inventory-notion.png' // Add your actual image path here
    },
    {
      title: 'Job Tracking Application + Resources',
      description: 'Streamline your job search with this Notion template.',
      type: 'Notion Pages',
      price: 'free',
      gumroadLink: 'https://captivlab.gumroad.com/l/jobtrackingfree?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=jobtracking',
      features: ['Track Companies', 'Job Openings', 'Interview Prep', 'Easy Access', 'Stay Organized'],
      image: '📊',
      productImage: '/images/job-tracking.png' // Add your actual image path here
    },
    {
      title: 'Premium AI Design Template Prompt',
      description: 'Instant AI-Powered Inspiration for Designers & Illustrators!',
      type: 'Notion Pages',
      price: 'free',
      gumroadLink: 'https://captivlab.gumroad.com/l/aidesignprompt?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=aiprompts',
      features: ['Highly optimized AI prompts', 'Customizable prompts', 'Compatible with multiple AI platforms', 'Speed Up Your Workflow'],
      image: '📊',
      productImage: '/images/ai-prompt.png' // Add your actual image path here
    },
    {
      title: 'Salon Appointment Management System',
      description: 'Manage your salon appointments with ease.',
      type: 'Notion Pages',
      price: 'paid',
      gumroadLink: 'https://captivlab.gumroad.com/l/salonappointment?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=salon',
      features: ['Simplify Scheduling', 'Track Client History', 'Organized Staff & Services', 'Never Miss a Booking'],
      image: '📊',
      productImage: '/images/salon.png' // Add your actual image path here
    },
    {
      title: 'Subscription Manager (Tracker)',
      description: 'Take control of your subscriptions and recurring expenses with ease!',
      type: 'Notion Pages',
      price: 'free',
      gumroadLink: 'https://captivlab.gumroad.com/l/subscriptionmanager?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=subscription',
      features: ['Track costs', 'Renewal Reminders', 'Expense Overview', 'Billing dates, platforms, and categories'],
      image: '📊',
      productImage: '/images/subscription.png' // Add your actual image path here
    },
    {
      title: 'Talent Matching Tracking Management',
      description: 'Unlock a faster, more efficient way to meet your talent needs',
      type: 'Notion Pages',
      price: 'free',
      gumroadLink: 'https://captivlab.gumroad.com/l/talentmatching?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=talent',
      features: ['External Talent Seeking', 'Internal Talent Matching', 'Reduce Time to Hire', 'Shorten Project Cycle Length'],
      image: '📊',
      productImage: '/images/talent.png' // Add your actual image path here
    },
    {
      title: 'Team Directory + HR Administration',
      description: 'Centralize company information and resources for your team',
      type: 'Notion Pages',
      price: 'free',
      gumroadLink: 'https://captivlab.gumroad.com/l/teamdirectory?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=teamdirectory',
      features: ['Employee Database', 'Company Handbook aka Learning Hub', 'Company Policies'],
      image: '📊',
      productImage: '/images/team.webp' // Add your actual image path here
    },
    {
      title: 'Visitor Management System',
      description: 'The smart, easy-to-use solution for streamlining the check-in and management process of visitors to your company or facility',
      type: 'Notion Pages',
      price: 'free',
      gumroadLink: 'https://captivlab.gumroad.com/l/visitorsystem?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=visitor',
      features: ['Secure Check-in', 'Visitor Tracking', 'Visitor Management', 'Visitor Notification'],
      image: '📊',
      productImage: '/images/visitor.png' // Add your actual image path here
    },
    
    {
      title: 'Elevate Your Communications: 30+ Premium Email Templates Bundled',
      description: 'Collection of responsive email templates for marketing campaigns and business communication.',
      type: 'Email Templates',
      price: 'free',
      gumroadLink: 'https://captivlab.gumroad.com/l/bundleemailtemplate?utm_source=website&utm_medium=website&utm_campaign=captivlab&utm_term=emailtemplate',
      features: ['Marketing Campaigns', 'Newsletters', 'Welcome Series', 'Event Invitations'],
      image: '📧',
      productImage: '/images/email.png' // Add your actual image path here
    },
    {
      title: 'WordGen - All-in-One Plugin AI Content Studio for WordPress',
      description: 'WordGen Studio is the ultimate AI-powered content creation suite for WordPress.',
      type: 'Wordpress Plugin',
      price: 'paid',
      gumroadLink: 'https://captivlab.gumroad.com/l/wordgen?utm_campaign=captivlab&utm_medium=website&utm_source=website',
      features: ['Content Creation Tools', 'Email & Outreach Power', 'Social Media & Branding', 'Product & Ecommerce'],
      image: '📊',
      productImage: '/images/wordgen.png' // Add your actual image path here
    },
   
  ];

  // Get unique product types for filter buttons
  const productTypes = ['all', ...Array.from(new Set(products.map(product => product.type)))];

  // Filter products based on active filter
  const filteredProducts = activeFilter === 'all' 
    ? products 
    : products.filter(product => product.type === activeFilter);

  return (
    <section id="products" className="section-padding bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Our Products
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Ready-to-use solutions that can transform your workflow and boost productivity.
          </p>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {productTypes.map((type) => (
            <button
              key={type}
              onClick={() => setActiveFilter(type)}
              className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                activeFilter === type
                  ? 'bg-primary-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
              }`}
            >
              {type === 'all' ? 'All Products' : type}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              {/* Product Image */}
              <div className="h-48 bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center">
                <div className="text-center">
                  {/* <div className="text-6xl mb-2">{product.image}</div>
                  <p className="text-gray-500 text-sm">Product Preview</p> */}
                </div>
                {/* Uncomment and replace with actual image when available */}
                <img 
                  src={product.productImage} 
                  alt={product.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="p-8">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-1">
                      {product.title}
                    </h3>
                    <span className="text-sm font-medium text-gray-500">
                      {product.type}
                    </span>
                  </div>
                  <div className="flex flex-col items-end">
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                      product.price === 'free' 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-primary-100 text-primary-800'
                    }`}>
                      {product.price === 'free' ? 'FREE' : 'PAID'}
                    </span>
                  </div>
                </div>

                <p className="text-gray-600 mb-6 leading-relaxed">
                  {product.description}
                </p>

                <ul className="space-y-2 mb-6">
                  {product.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-600">
                      <svg className="w-4 h-4 text-primary-600 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>

                <a
                  href={product.gumroadLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`block w-full text-center py-3 px-6 rounded-lg font-medium transition-colors duration-200 ${
                    product.price === 'free'
                      ? 'bg-green-600 hover:bg-green-700 text-white'
                      : 'btn-primary'
                  }`}
                >
                  {product.price === 'free' ? 'Get Free Template' : 'Buy Now'}
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* No results message */}
        {filteredProducts.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">No products found for this category.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Products;
